import {FontAsset} from "@nolimitcity/slot-keypad/bin/core/loaders/font/FontCache";
import {FontStyle, FontWeight} from "@nolimitcity/slot-keypad/bin/core/loaders/font/FontStatics";

export class AlfaSlabOne {
    public static readonly FAMILY: string = "AlfaSlabOne-Regular";
    static readonly BASE_URL: string = "/resources/fonts/";

    public static REGULAR: FontAsset = {
        family: AlfaSlabOne.FAMILY,
        weight: FontWeight.BOLD,
        style: FontStyle.NORMAL,
        url: AlfaSlabOne.BASE_URL + "AlfaSlabOne-Regular.ttf"
    }
}

export class ariblk {
    public static readonly FAMILY: string = "ariblk";
    private static readonly BASE_URL: string = "/resources/fonts/";

    public static REGULAR: FontAsset = {
        family: ariblk.FAMILY,
        weight: FontWeight.NORMAL,
        style: FontStyle.NORMAL,
        url: ariblk.BASE_URL + "ariblk.ttf"
    }

}